import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const usePostCertification = () => {
  const postCertification = async (payload) => {
    try {
      const url = `${getApiUrl()}/certification`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postCertification;
};

export const usePutCertification = () => {
  const putCertification = async (id, payload) => {
    try {
      const url = `${getApiUrl()}/certification/${id}`;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return putCertification;
};

export const useDeleteCertification = () => {
  const deleteCertification = async (id) => {
    try {
      const url = `${getApiUrl()}/certification/${id}`;
      const response = await axios.delete(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return deleteCertification;
};

export const useListCertifications = ({ coachId, coachActivityId }) => {
  const queryParams = new URLSearchParams();
  if (coachId) {
    queryParams.append('coachId', coachId);
  }
  if (coachActivityId) {
    queryParams.append('coachActivityId', coachActivityId);
  }
  const urlStr = `${getApiUrl()}/certification?${queryParams.toString()}`;
  const swr = useSWR(
    urlStr,
    async (url) => {
      try {
        const result = await axios.get(url);
        return result.data;
      } catch (err) {
        throw Error(err);
      }
    },
    {
      dedupingInterval: 30000, // 30 seconds
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  return swr;
};
